import type { SimpleOption } from '@elfsight/configurator-contracts';
import type { Device } from '../types';

export const devicesDisplayOptions: SimpleOption<Device>[] = [
  {
    value: 'desktop',
    label: 'Desktop'
  },
  {
    value: 'tablet',
    label: 'Tablet'
  },
  {
    value: 'mobile',
    label: 'Mobile'
  }
];
